import axios from "axios";
import { API, authHeaders } from "./adminAuth";

const h = () => ({ headers: authHeaders() });

// Submissions (inbox)
export const listSubmissions = (department) =>
  axios.get(`${API}/contact`, { ...h(), params: department ? { department } : {} }).then((r) => r.data);
export const setSubmissionStatus = (id, status) =>
  axios.patch(`${API}/contact/${id}/status`, { status }, h()).then((r) => r.data);
export const convertSubmission = (id, body) =>
  axios.post(`${API}/crm/inquiries/from-submission/${id}`, body, h()).then((r) => r.data);

// Dashboard
export const getDashboard = (followup_days) =>
  axios.get(`${API}/crm/dashboard`, { ...h(), params: followup_days ? { followup_days } : {} }).then((r) => r.data);
export const getSettings = () => axios.get(`${API}/crm/settings`, h()).then((r) => r.data);
export const updateSettings = (b) => axios.patch(`${API}/crm/settings`, b, h()).then((r) => r.data);

// Reps
export const listReps = () => axios.get(`${API}/crm/reps`, h()).then((r) => r.data);
export const createRep = (b) => axios.post(`${API}/crm/reps`, b, h()).then((r) => r.data);
export const updateRep = (id, b) => axios.patch(`${API}/crm/reps/${id}`, b, h()).then((r) => r.data);
export const deleteRep = (id) => axios.delete(`${API}/crm/reps/${id}`, h());

// Companies
export const listCompanies = () => axios.get(`${API}/crm/companies`, h()).then((r) => r.data);
export const getCompany = (id) => axios.get(`${API}/crm/companies/${id}`, h()).then((r) => r.data);
export const createCompany = (b) => axios.post(`${API}/crm/companies`, b, h()).then((r) => r.data);
export const updateCompany = (id, b) => axios.patch(`${API}/crm/companies/${id}`, b, h()).then((r) => r.data);
export const deleteCompany = (id) => axios.delete(`${API}/crm/companies/${id}`, h());
export const addActivity = (id, b) => axios.post(`${API}/crm/companies/${id}/activities`, b, h()).then((r) => r.data);
export const createLocation = (companyId, b) => axios.post(`${API}/crm/companies/${companyId}/locations`, b, h()).then((r) => r.data);
export const updateLocation = (id, b) => axios.patch(`${API}/crm/locations/${id}`, b, h()).then((r) => r.data);
export const deleteLocation = (id) => axios.delete(`${API}/crm/locations/${id}`, h());

// Inquiries
export const listInquiries = (params = {}) =>
  axios.get(`${API}/crm/inquiries`, { ...h(), params }).then((r) => r.data);
export const createInquiry = (b) => axios.post(`${API}/crm/inquiries`, b, h()).then((r) => r.data);
export const updateInquiry = (id, b) => axios.patch(`${API}/crm/inquiries/${id}`, b, h()).then((r) => r.data);
export const deleteInquiry = (id) => axios.delete(`${API}/crm/inquiries/${id}`, h());

// Orders
export const listOrders = (params = {}) =>
  axios.get(`${API}/crm/orders`, { ...h(), params }).then((r) => r.data);
export const createOrder = (b) => axios.post(`${API}/crm/orders`, b, h()).then((r) => r.data);
export const updateOrder = (id, b) => axios.patch(`${API}/crm/orders/${id}`, b, h()).then((r) => r.data);
export const deleteOrder = (id) => axios.delete(`${API}/crm/orders/${id}`, h());

// Admin users
export const listUsers = () => axios.get(`${API}/admin/users`, h()).then((r) => r.data);
export const createUser = (b) => axios.post(`${API}/admin/users`, b, h()).then((r) => r.data);
export const resetUserPassword = (id, new_password) =>
  axios.post(`${API}/admin/users/${id}/reset-password`, { new_password }, h());
export const deleteUser = (id) => axios.delete(`${API}/admin/users/${id}`, h());
export const updateUserRole = (id, role) =>
  axios.patch(`${API}/admin/users/${id}/role`, { role }, h()).then((r) => r.data);

export const STAGES = ["New", "Contacted", "Quoted", "Sample Sent", "Discovery", "Won", "Lost"];
export const ORDER_STATUSES = ["Quoted", "Placed", "Shipped", "Closed"];
export const FORM_TYPES = { contact: "Contact", request_info: "Request Info", request_samples: "Request Samples" };
